import { render, staticRenderFns } from "./ChatInfo.vue?vue&type=template&id=50fe0e58&scoped=true"
import script from "./ChatInfo.vue?vue&type=script&lang=js"
export * from "./ChatInfo.vue?vue&type=script&lang=js"
import style0 from "./ChatInfo.vue?vue&type=style&index=0&id=50fe0e58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe0e58",
  null
  
)

export default component.exports